var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#00d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#00c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#00b2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00adff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48,24A24,24,0,1,1,24,0,24,24,0,0,1,48,24Zm0,0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.713 8.713)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M218.073,92.934h-13.94a1.406,1.406,0,0,0,0,2.813h3.005v4.422h-.359a1.406,1.406,0,0,0,0,2.813h3.529a1.406,1.406,0,0,0,0-2.812h-.358V95.746h8.123a2.125,2.125,0,0,1,2.123,2.123v2.3h-2.658V99.81a1.406,1.406,0,0,0-2.813,0v3.529a1.406,1.406,0,0,0,2.813,0v-.359H220.2v4.887a2.125,2.125,0,0,1-2.123,2.123h-.235a1.406,1.406,0,0,0,0,2.813h.235a4.941,4.941,0,0,0,4.935-4.935v-10A4.941,4.941,0,0,0,218.073,92.934Zm0,0",
    transform: "translate(-192.433 -92.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M213.034,241.9h-1.947v-2.005a1.406,1.406,0,1,0-2.812,0v11.764a.948.948,0,0,1-.946.947h-1.941a1.406,1.406,0,0,0,0,2.813h1.941a3.763,3.763,0,0,0,3.759-3.759v-6.946h1.947a1.406,1.406,0,0,0,0-2.813Zm0,0",
    transform: "translate(-193.57 -224.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M104.039,110.927V107.4a1.406,1.406,0,0,0-2.812,0v.417H95.746V97.869a2.125,2.125,0,0,1,2.123-2.123h.882a1.406,1.406,0,0,0,0-2.812h-.882a4.941,4.941,0,0,0-4.935,4.935v20.7a4.941,4.941,0,0,0,4.935,4.935h.941a1.406,1.406,0,0,0,0-2.812h-.941a2.125,2.125,0,0,1-2.123-2.123v-7.946h5.481v.3a1.406,1.406,0,1,0,2.813,0Zm0,0",
    transform: "translate(-92.934 -92.934)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.0ab3b4b22a6cc5b51b9d1c4fe264ae4f.svg";
export { ForwardRef as ReactComponent };